
<div class="w-100" style="padding-right: 75px">
    <c-app-home-bar
        :search-on-focus = "searchOnFocus"
    />

    <div
        v-if = "!sites && !hideTop"
        class="primary top-empty"
    >
    </div>

    <c-site-data-row
        v-if   = "sites"
        :sites = "sites"
        style  = "min-height: 142px"
    />

    <v-container class="content-panel">
        <slot name="content"></slot>
    </v-container>
</div>
